import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';

const Location = () => {

  const openMap = () => {
    const address = "1+Old+Trenton+Rd,+Cranbury,+NJ,+08512";
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIOS) {
      window.location.href = `https://maps.apple.com/?q=${address}`;
    } else {
      window.location.href = `https://www.google.com/maps/search/?api=1&query=${address}`;
    }
  };

  return (
    <Container className='d-flex justify-content-center sectionalContainer'>
        <Row>
            <Col lg={12} className='m-0 p-0'>
                <Container className = 'w-100 justify-content-center d-flex'>
                    <button onClick={openMap} className='locationMapBtn'>1 Old Trenton Rd, Cranbury, NJ, 08512</button>        
                </Container>
            </Col>
            <Col lg={12} className='m-0 p-0'>
                <iframe 
                    className='locationMap'
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3042.790429094476!2d-74.52491192318737!3d40.302611971458056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3debd63fbee89%3A0xcda53c59ab205cc4!2s1%20Old%20Trenton%20Rd%2C%20Cranbury%2C%20NJ%2008512!5e0!3m2!1sen!2sus!4v1736661313992!5m2!1sen!2sus"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="1 Old Trenton Rd, Cranbury, NJ, 08512"
                    allowFullScreen
                    loading="lazy"
                />
            </Col>
        </Row>
    </Container>
  );
};

export default Location;
